import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { IntegrationCompany, integrationsByCompany, LocalEditableIntegration } from "../../../Everou/_modelsTS/Integration";
import { MainPageWithButtons } from "../../../Everou/_components";
import { removeFromArr } from "../../../Common/_utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { Selectors } from "../../../Everou/_reducers/app.reducer";
import { PMSIntegrationsActions } from "../../_actions/PMSIntegrationsActions";
import { PMSThreeAngularIntegrationInput } from "../_components/PMSThreeAngularIntegrationInput";
import { useAccountDraft } from "../_hooks/useAccountDraft";

export function PMSThreeAngularIntegration() {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    
    const serverIntegrations = useSelector(Selectors.getPMSIntegrationsInPanel);
    const accountDraft = useAccountDraft(IntegrationCompany.THREE_ANGULAR);
    const serverEditableIntegrations = serverIntegrations.map(integration => ({ ...integration, editable: false }))

    const [integrationsLocal, setIntegrationsLocal ] = useState<LocalEditableIntegration[]>([]);

    useEffect(() => {
        const updatedIntegrations = integrationsByCompany(serverIntegrations, IntegrationCompany.THREE_ANGULAR, accountDraft);
        setIntegrationsLocal(updatedIntegrations);
    }, [serverIntegrations, accountDraft, setIntegrationsLocal]);

    const onDeleteIntegration = (index: number) => {
        const integration = integrationsLocal[index];
        if(!integration.uid) {
            setIntegrationsLocal(removeFromArr<LocalEditableIntegration>(index, integrationsLocal))
        } else {
            dispatch(PMSIntegrationsActions.deleteIntegration(integration.uid))
            setIntegrationsLocal(removeFromArr<LocalEditableIntegration>(index, integrationsLocal))
        }
    }

    const body = (
        <div className="c-grid c-grid--small rounded-bottom">
            {integrationsLocal.map((integration, index) => (
                <PMSThreeAngularIntegrationInput
                    key={integration.uid || "new"}
                    onDelete={index => onDeleteIntegration(index)}
                    index={index}
                    integration={integration}
                />
            ))}
            
        </div>
    );

    return (
        <MainPageWithButtons
            //dataTestId={testIDs.root}
            pageTitle={t("mod_integrations_three_angular_title")}
            content={body}
        />
    );
}

